<template>
  <eg-b-form-group>
    <div class="d-flex flex-gap-1">
      <ToggleButton
        v-for="radioOption in radioOptions"
        :key="radioOption.value"
        class="btn d-flex align-center"
        :horizontal="true"
        :value="radioOption.value"
        :label="$t(radioOption.translationKey)"
        :pressed="value === radioOption.value"
        @click="handleChange(radioOption.value)"
      />
    </div>
  </eg-b-form-group>
</template>

<script>
import ToggleButton from "@/components/global/eg_toggle_button.vue";
import { INTENSITIES } from "@/constants";

export default {
  components: { ToggleButton },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      radioOptions: INTENSITIES,
    };
  },
  methods: {
    handleChange(valueId) {
      this.$emit("input", valueId);
    },
  },
};
</script>
